import Vue from 'vue';
import Vuex from 'vuex';

import { requester } from '@/helpers/requester.js';

Vue.use(Vuex);

const LOCALE_KEY = 'locale';

export default new Vuex.Store({
  state: {
    isLoggedIn: false,
    locale() {
      const locale =
        window.localStorage.getItem(LOCALE_KEY) || window.navigator.language;
      return locale || 'el';
    },
    employeeData: null,
    recruitmentData: null,
    isLoadingEmployee: false,
    selectedSlmType: localStorage.getItem('slmType'),
    selectedDepartment: localStorage.getItem('department')
  },
  getters: {
    hasEmployeeData(state) {
      return state.employeeData != null;
    },
    recruitmentInfo(state) {
      return state.recruitmentData;
    },
    userInfo(state) {
      return state.employeeData?.user_info;
    },
    workingCity(state) {
      return state.employeeData?.employee_info?.working_city;
    },
    slmType(state) {
      return (
        state.employeeData?.employee_info?.employment_type ??
        state.selectedSlmType
      );
    },
    department(state) {
      return (
        state.selectedDepartment ||
        (state.employeeData?.employee_info?.is_only_warehouser
          ? 'warehouse'
          : 'drivers')
      );
    },
    isSlmTypeCompleted(state) {
      return state.employeeData?.employee_info?.employment_type !== null;
    },
    isDepartmentCompleted(state) {
      return state.employeeData?.employee_info?.is_only_warehouser !== null;
    },
    isEmployeeCompleted(state) {
      return (
        state.employeeData?.user_info.first_name?.length > 0 &&
        state.employeeData.user_info.last_name?.length > 0 &&
        state.employeeData.user_info.email?.length > 0 &&
        state.employeeData.user_info.phone?.length > 0 &&
        state.employeeData.employee_info?.working_city?.id != null
      );
    }
  },
  mutations: {
    updateUserLoggedIn(state, isLoggedIn) {
      state.isLoggedIn = isLoggedIn;
    },
    onLocaleChanged(state, payload) {
      window.localStorage.setItem(LOCALE_KEY, payload.locale);

      payload.i18n.locale = payload.locale;

      state.locale = payload.locale;
    },
    updateEmployeeData(state, data) {
      state.employeeData = data;
    },
    updateRecruitmentData(state, data) {
      state.recruitmentData = data;
    },
    updateIsLoadingEmployee(state, isLoading) {
      state.isLoadingEmployee = isLoading;
    },
    setUserFirstName(state, firstName) {
      state.employeeData.user_info.first_name = firstName;
    },
    setUserLastName(state, lastName) {
      state.employeeData.user_info.last_name = lastName;
    },
    setUserEmail(state, email) {
      state.employeeData.user_info.email = email;
    },
    setUserPhone(state, phone) {
      state.employeeData.user_info.phone = phone;
    },
    setWorkingCity(state, cityId) {
      if (state.employeeData.employee_info.working_city != null) {
        state.employeeData.employee_info.working_city.id = cityId;
      } else {
        state.employeeData.employee_info.working_city = { id: cityId };
      }
    },
    setSlmType(state, type) {
      state.employeeData.employee_info.employment_type = type;
    },
    setIsWarehouse(state, department) {
      state.employeeData.employee_info.is_only_warehouser =
        department === 'warehouse';
    },
    setSelectedSlmType(state, type) {
      localStorage.setItem('slmType', type);
      state.selectedSlmType = type;
    },
    setSelectedDepartment(state, department) {
      localStorage.setItem('department', department);
      state.selectedDepartment = department;
    }
  },
  actions: {
    changeLocale({ commit }, payload) {
      commit('onLocaleChanged', payload);
    },
    async requestEmployee({ commit }) {
      commit('updateIsLoadingEmployee', true);
      const r = await requester();

      try {
        const response = await r.get('/me');

        commit('updateEmployeeData', response.data.employee);
        commit('updateRecruitmentData', response.data.recruitment);
      } finally {
        commit('updateIsLoadingEmployee', false);
      }
    },
    async editEmployee({ commit, state }) {
      commit('setSlmType', state.selectedSlmType);
      commit('setIsWarehouse', state.selectedDepartment);

      const r = await requester();

      const response = await r.post('/edit', {
        employee: this.state.employeeData
      });

      commit('updateEmployeeData', response.data.employee);
    }
  },
  modules: {}
});
